<script>
    import Vue from 'vue'
    import Router from 'vue-router'
    Vue.use(Router);

    import Home from '../pages/Home.vue'
    import Login from '../pages/Login.vue'
    import loginTest from '../pages/loginTest.vue'
    import PageError from "../pages/PageError"
    import Case from '../pages/case/Case.vue'
    import User from '../pages/case/User.vue'
    import Email from '../pages/case/Email.vue'
    import Todo from '../pages/case/Todo.vue'
    import router from "vue-bootstrap-typeahead/src/router";

    const routes = [
        {
            path: '',
            component: () => import('../layouts/Main.vue'),
            children: [
                {path: '/', redirect: '/Login'},
                // {path: '/', redirect: '/Home'},
                {
                    path: '/Home',
                    // component:Home,
                    component:()=> import('../pages/Home.vue'),
                    name: 'Home',
                    meta:{ requireAuth : true },
                },
                // {path: '/Case', component:Case, name: 'Case'},
                // {path: '/User', component:User, name: 'User'},
                // {path: '/Email', component:Email, name: 'Email'},
                // {path: '/Todo', component:Todo, name: 'Todo'},
            ]
        },
        {
            path: '/Login',
            // component: Login,
            component:()=> import('../pages/Login.vue'),
            name:'Login'
        },
        {
            path: '/loginTest',
            // component: loginTest,
            component:()=> import('../pages/loginTest.vue'),
            name:'loginTest'
        },
        {
            path: '/PageError',
            // component:PageError,
            component:()=> import('../pages/PageError.vue'),
            name: 'PageError'
        },
        {
            path: '*',
            redirect: '/PageError'
        }

    ];


    export default routes;
</script>
